import { Component, inject, Input, OnChanges } from '@angular/core';
import { DsButtonModule, DsButtonVariants } from '@levelaccess/design-system';
import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';
import { AiChatNavigationService } from '../../ai-chat-navigation.service';
import { toPlatformPath } from '../generative-components.utils';

@Component({
  selector: 'app-ai-chat-generative-button',
  template: `
    <a ds-button [href]="href" [variant]="variant" [isExternalLink]="isExternal" (click)="onNavigate($event)">
      {{ label }}
    </a>
  `,
  styleUrls: ['./ai-chat-button.component.scss'],
  imports: [DsButtonModule],
  standalone: true,
})
export class AiChatGenerativeButtonComponent implements OnChanges {
  @Input() public chunk: IChatV2ComponentChunk;

  private readonly aiChatNavigationService: AiChatNavigationService = inject(AiChatNavigationService);

  public label: string = '';
  public href: string = '';
  public variant: DsButtonVariants = DsButtonVariants.secondary;
  public isExternal: boolean = false;

  public static serialize(): string {
    // Buttons link back into the platform and are meaningless once pasted outside it
    return '';
  }

  public ngOnChanges(): void {
    const data = this.chunk?.data ?? {};
    this.label = (data['label'] as string) ?? '';
    const rawHref = (data['href'] as string) ?? '';
    this.href = toPlatformPath(rawHref) ?? rawHref;
    this.isExternal = (data['isExternal'] as boolean) ?? false;

    const rawVariant = data['variant'] as string;
    this.variant =
      rawVariant && Object.values(DsButtonVariants).includes(rawVariant as DsButtonVariants)
        ? (rawVariant as DsButtonVariants)
        : DsButtonVariants.secondary;
  }

  public onNavigate(event: MouseEvent): void {
    if (!this.isExternal && this.aiChatNavigationService.navigateTo(this.href)) {
      event.preventDefault();
    }
  }
}
